import Image, { type ImageProps } from 'next/image';
import { type ThemedImageName } from './themedImages';
import { useThemedImageSource } from './useThemedImageSource';

type ThemedImageProps = Omit<ImageProps, 'src'> & {
  /** Registry key — the original SVG file basename, e.g. `errorIcon`. */
  name: ThemedImageName;
};

/**
 * The single place in the app that renders a themed SVG through `next/image`.
 * The light/dark decision is owned by `useThemedImageSource`; for components
 * that need the raw image source instead of a rendered `<Image>` (e.g.
 * honeypot-ui's `NavigationItem`), use that hook directly.
 */
export function ThemedImage({ name, alt, ...rest }: ThemedImageProps) {
  const src = useThemedImageSource(name);

  return <Image src={src} alt={alt} {...rest} />;
}
